import { createRoute } from '@tanstack/react-router';
import { IconPresentationAnalytics } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { readFinanceAccess } from '../finance/access';
import { Bod } from './Bod';

/** Luồng N · Báo cáo BOD: menu chỉ hiện cho người có quyền tiền; tab không tiền đọc được khi `money=hide`. */
const bod: EzyModule = {
  nav: typeof location !== 'undefined' && readFinanceAccess(location.search).money
    ? { key: 'bod', label: 'Báo cáo BOD', icon: IconPresentationAnalytics, items: [{ key: 'bod', label: 'Báo cáo BOD', to: '/ezy/bod' }] }
    : undefined,
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/bod', component: Bod })],
};
export default bod;
